/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Mfa_Password_LabelInputs */

const de_auth_mfa_password_label = /** @type {(inputs: Auth_Mfa_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort`)
};

/** @type {(inputs: Auth_Mfa_Password_LabelInputs) => LocalizedString} */
const en_auth_mfa_password_label = de_auth_mfa_password_label;

/**

* @param {Auth_Mfa_Password_LabelInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_mfa_password_label = /** @type {((inputs?: Auth_Mfa_Password_LabelInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Mfa_Password_LabelInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_mfa_password_label(inputs)
	return en_auth_mfa_password_label(inputs)
});